export interface ManufacturerMarkup {
  name: string
  markup: number
}

export const DEFAULT_MANUFACTURER_MARKUPS: ManufacturerMarkup[] = [
  { name: 'Бергер', markup: 140 },
  { name: 'Магнат', markup: 130 },
  { name: 'Талант', markup: 150 },
]

const MANUFACTURER_LEGAL_FORMS = new Set(['ооо', 'оао', 'ао', 'зао', 'ип', 'пк'])
const CYRILLIC_TO_LATIN: Record<string, string> = { а: 'a', б: 'b', в: 'v', г: 'g', д: 'd', е: 'e', ё: 'e', ж: 'zh', з: 'z', и: 'i', й: 'i', к: 'k', л: 'l', м: 'm', н: 'n', о: 'o', п: 'p', р: 'r', с: 's', т: 't', у: 'u', ф: 'f', х: 'h', ц: 'c', ч: 'ch', ш: 'sh', щ: 'shch', ъ: '', ы: 'y', ь: '', э: 'e', ю: 'yu', я: 'ya' }

/** Browser-safe canonical manufacturer key used by the settings picker and server aggregation. */
export function canonicalManufacturerKey(value: string): string {
  const words = value.normalize('NFKC').toLocaleLowerCase('ru-RU').replace(/[«»"'.,()[\]{}_-]+/g, ' ').split(/\s+/).filter(word => word && !MANUFACTURER_LEGAL_FORMS.has(word))
  const transliterated = words.join(' ').split('').map(character => CYRILLIC_TO_LATIN[character] ?? character).join('').replace(/[^a-z0-9]+/g, '')
  return transliterated || value.toLocaleLowerCase('ru-RU').replace(/\s+/g, '')
}
